/**
 * Split a flat list into N balanced columns (round-robin).
 */
export function splitIntoColumns(items = [], columnCount = 4) {
  const cols = Array.from({ length: columnCount }, () => []);
  items.forEach((item, index) => {
    cols[index % columnCount].push(item);
  });
  return cols.filter((col) => col.length > 0);
}
